import { render, staticRenderFns } from "./Importar_Aceite_Sernapesca.vue?vue&type=template&id=e673fd70&scoped=true&"
import script from "./Importar_Aceite_Sernapesca.vue?vue&type=script&lang=js&"
export * from "./Importar_Aceite_Sernapesca.vue?vue&type=script&lang=js&"
import style0 from "./Importar_Aceite_Sernapesca.vue?vue&type=style&index=0&id=e673fd70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e673fd70",
  null
  
)

export default component.exports